import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAllCurrencyService, getGameDetailsService, verifyRoundHashService } from 'network/services/gameSettings.service'
import { setAllCurrency } from 'redux-thunk/redux/slices/gameSettings.slice'

export const getAllCurrency = createAsyncThunk('user/getAllCurrency', async (_, thunkApi) => {
  try {
    const res = await getAllCurrencyService()
    const currencies = Array.isArray(res) ? res : (res?.data ?? [])
    thunkApi.dispatch(setAllCurrency(currencies))
    return currencies
  } catch (error) {
    const errors = Array.isArray(error) ? error : (error?.response?.data?.errors ?? [])
    const message = errors[0]?.description ?? 'Failed to load currencies'
    return thunkApi.rejectWithValue(message)
  }
})

export const getGameDetails = createAsyncThunk('system/get-game-details', async (_, thunkApi) => {
  try {
    const res = await getGameDetailsService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const roundVerifyHash = createAsyncThunk(
  'verify/game-hash',
  async (data, thunkApi) => {
    try {
      const res = await verifyRoundHashService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
